import { createAsyncIcon } from '../_factory/createAsyncIcon';

const AsyncRemixIcon = createAsyncIcon(() => import('./RemixIcon'));

export default AsyncRemixIcon;

AsyncRemixIcon.displayName = 'AsyncRemixIcon';
